import { Modal, defineModal } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import FormNewUser from '@spa/components/FormNewUser'
import { useMemoSelector } from '@spa/redux/hooks'
import type { FC } from 'react'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getCurrentAccountId } from 'snap-redux/modules/accounts/selectors'
import { fetchPayPeriods } from 'snap-redux/modules/payPeriods'
import { getPrincipalLockedPayPeriodsForAccount } from 'snap-redux/modules/payPeriods/selectors'

type CreateMembershipModalProps = {
  teamId: number
  locationId: number
}

export const createMembershipModalDef = defineModal<CreateMembershipModalProps>(
  {
    name: 'createMembershipModal'
  }
)

const CreateMembershipModal: FC = () => {
  const { close, isOpen, data } = createMembershipModalDef.useModal()

  const { t } = usePlanningFormTranslation()
  const dispatch = useDispatch()
  const accountId = useMemoSelector(getCurrentAccountId)
  const lockedPayPeriods = useMemoSelector(state =>
    getPrincipalLockedPayPeriodsForAccount(state, accountId)
  )

  useEffect(() => {
    // @ts-ignore migration from js(x) to ts(x)
    dispatch(fetchPayPeriods(accountId))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal height='m' onClose={close} opened={isOpen} variant='right'>
      <Modal.Header title={t('newEmployeeForm.title')} />
      <FormNewUser
        formSuccess={close}
        lockedPayPeriods={lockedPayPeriods}
        // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
        locationId={data.locationId}
        // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
        teamId={data.teamId}
      />
    </Modal>
  )
}

export default createMembershipModalDef.withModalShow(CreateMembershipModal)
